module.exports = __webpack_public_path__ + "media/images/default/shared/header/booking-35951fe4da769e8a06895203d2144efc.svg";